<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNewTreatyPeriod()">
            New Treaty Period
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="listItems"
          v-bind:options.sync="pagination"
          :server-items-length="totalItems"
          :search="search"
          :loading="loading"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td class="text-xs-left">{{ row.item.ttyNo }}</td>
              <td class="text-xs-left">{{ row.item.ttyYr }}</td>
              <td class="text-xs-left">{{ formatDisplayDate(row.item.comDate) }}</td>
              <td class="text-xs-left">{{ formatDisplayDate(row.item.expDate) }}</td>
              <td class="table-action-header">
                <table-action
                  :rowData="row"
                  query
                  @query="doTreatyPeriodQuery(row.item)"
                  review
                  @review="doTreatyPeriodReview(row.item)"
                  remove
                  @remove="doPromptRemove(row.item)"
                ></table-action>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <!-- <form data-vv-scope="treatyPeriodForm"> -->
          <form data-vv-scope="treatyPeriodForm">
            <v-expansion-panels :value="treatyPeriodDetail" :disabled="treatyPeriodForm.treatyPeriodAction === undefined">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div v-if="treatyPeriodForm.treatyPeriodAction === 'new'">
                    <v-icon>mdi-filter-variant</v-icon>Treaty Period Details
                    <span class="caption grey--text font-weight-light">(New)</span>
                  </div>
                  <div v-else-if="treatyPeriodForm.treatyPeriodAction === 'review'">
                    <v-icon>mdi-filter-variant</v-icon>Treaty Period Details
                    <span class="caption grey--text font-weight-light">(Review)</span>
                  </div>
                  <div v-else-if="treatyPeriodForm.treatyPeriodAction === 'query'">
                    <v-icon>mdi-filter-variant</v-icon>Treaty Period Details
                    <span class="caption grey--text font-weight-light">(Query)</span>
                  </div>
                  <div v-else><v-icon>mdi-filter-variant</v-icon>Treaty Period Details</div>
                </v-expansion-panel-header>
                <!-- <v-toolbar dense color="grey lighten-3" flat>
                  <v-icon v-if="newMode">mdi-plus</v-icon>
                  <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
                  <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
                  <v-toolbar-title v-if="newMode">Create New Co / RI Panel</v-toolbar-title>
                  <v-toolbar-title v-else-if="reviewMode">Edit Co / RI Panel</v-toolbar-title>
                  <v-toolbar-title v-else-if="queryMode">Query Co / RI Panel</v-toolbar-title>
                </v-toolbar> -->
                <v-expansion-panel-content>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field
                            v-model="treatyPeriodForm.ttyNo"
                            :label="labels.ttyNo"
                            :error-messages="errors.collect('treatyPeriodForm.ttyNo')"
                            data-vv-name="treatyPeriodForm.ttyNo"
                            :data-vv-as="labels.ttyNo"
                            :disabled="true"
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field
                            v-model="treatyPeriodForm.ttyYr"
                            :label="labels.ttyYr"
                            :error-messages="errors.collect('treatyPeriodForm.ttyYr')"
                            data-vv-name="treatyPeriodForm.ttyYr"
                            :data-vv-as="labels.ttyYr"
                            :disabled="treatyPeriodForm.treatyPeriodAction !== 'new'"
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg4 md4 xs12>
                          <cal-picker
                            :label="labels.comDate"
                            v-model="treatyPeriodForm.comDate"
                            :error-messages="errors.collect('treatyPeriodForm.comDate')"
                            data-vv-name="treatyPeriodForm.comDate"
                            :data-vv-as="labels.comDate"
                            v-validate="checkComDateValidation"
                            :disabled="treatyPeriodForm.treatyPeriodAction === 'query'"
                          ></cal-picker>
                        </v-flex>
                        <v-flex lg4 md4 xs12>
                          <cal-picker
                            :label="labels.expDate"
                            v-model="treatyPeriodForm.expDate"
                            :error-messages="errors.collect('treatyPeriodForm.expDate')"
                            data-vv-name="treatyPeriodForm.expDate"
                            :data-vv-as="labels.expDate"
                            v-validate="checkExpDateValidation"
                            :disabled="treatyPeriodForm.treatyPeriodAction === 'query'"
                          ></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn class="white--text error" @click.prevent="doCancel">
                      Cancel
                      <v-icon right>mdi-exit-to-app</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="this.treatyPeriodForm.treatyPeriodAction !== 'query'"
                      color="primary"
                      type="submit"
                      :loading="submitting"
                      @click.prevent="doSave"
                    >
                      Save
                      <v-icon right>{{ treatyPeriodForm.treatyPeriodAction === 'new' ? 'mdi-plus' : 'mdi-content-save' }}</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
      </v-card>
    </div>
    <!--Start Delete Prompt -->
    <confirm v-model="promptRemove" @ok="doDeleteTreatyPeriod">
      <p>{{ labels.promptRemoveTreatyPeriod }}</p>
      <div class="queryValue">{{ deleteTreatyPeriod }}</div>
    </confirm>
    <!-- End Delete Prompt-->
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate, removeTime } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import isAfter from 'date-fns/isAfter'

export default {
  data() {
    return {
      headers: [
        { text: 'Treaty No.', value: 'ttyNo' },
        { text: 'Treaty Year', value: 'ttyYr' },
        { text: 'Comm Date', value: 'comDate' },
        { text: 'Expiry Date', value: 'expDate' },
        TableConst.tableActionHeader
      ],
      labels: {
        ttyNo: 'Treaty No.',
        ttyYr: 'Treaty Year',
        comDate: 'Comm Date',
        expDate: 'Expiry Date',
        promptRemoveTreatyPeriod: 'Are you sure you want to delete the selected Treaty Period'
      },
      treatyPeriodForm: {
        treatyPeriodAction: undefined,
        ttyNo: undefined,
        ttyNoDesc: undefined,
        ttyYr: undefined,
        comDate: undefined,
        expDate: undefined
      },
      promptRemove: false,
      loading: false,
      submitting: false,
      deleteTreatyPeriod: undefined,
      selectTreatyPeriod: undefined,
      checkTreatyPeriodFound: false,
      totalItems: 0,
      listItems: [],
      treatyPeriodDetail: false,
      search: undefined,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    async doInit() {
      const apiUrl = this.treatyMenu.treatyPeriodList
      if (apiUrl) {
        this.loading = true
        try {
          const expand = { ttyNo: this.ttyNoParam }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            this.totalItems = data.totalElements
            this.listItems = []
            data.map((treatyPeriodMap) => {
              const convertList = {
                ttyNo: treatyPeriodMap.ttyNo,
                ttyYr: treatyPeriodMap.ttyYr,
                comDate: treatyPeriodMap.comDate,
                expDate: treatyPeriodMap.expDate
              }
              this.listItems.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
      }
    },
    doNewTreatyPeriod() {
      // console.log(this.ttyForm)
      this.treatyPeriodForm.treatyPeriodAction = 'new'
      let comDateYear = new Date().getFullYear()
      if (this.ttyForm.comDate !== null) {
        comDateYear = this.ttyForm.ttyYr
      }
      this.treatyPeriodDetail = true
      this.treatyPeriodForm.ttyNo = this.ttyNoParam
      this.treatyPeriodForm.ttyYr = this.ttyForm.ttyYr
      this.treatyPeriodForm.comDate = new Date(comDateYear, 0, 1)
      this.treatyPeriodForm.expDate = new Date(comDateYear, 11, 31)
    },
    doTreatyPeriodQuery(data) {
      this.treatyPeriodForm.treatyPeriodAction = 'query'
      this.doFetchData(data)
    },
    doTreatyPeriodReview(data) {
      this.treatyPeriodForm.treatyPeriodAction = 'review'
      this.doFetchData(data)
    },
    doPromptRemove(item) {
      this.promptRemove = true
      this.labels.promptRemoveTreatyPeriod =
        'You have chosen to delete this record, Treaty No.: ' +
        item.ttyNo +
        ' Treaty Year: ' +
        item.ttyYr +
        ' . Do you really want to delete this record?'
      this.selectTreatyPeriod = item
      this.deleteTreatyPeriod = item.ttyNo + ' - ' + item.ttyYr
    },
    doCancel() {
      this.treatyPeriodForm.treatyPeriodAction = undefined
      this.treatyPeriodDetail = false
    },
    async doFetchData(treatyPeriod) {
      const apiUrl = this.treatyMenu.getTreatyPeriod
      if (apiUrl) {
        this.loading = true
        try {
          const expand = {
            ttyNo: treatyPeriod.ttyNo,
            ttyYr: treatyPeriod.ttyYr
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const data = result.data
          if (data) {
            this.treatyPeriodForm.ttyNo = data.ttyNo
            this.treatyPeriodForm.ttyYr = data.ttyYr
            this.treatyPeriodForm.comDate = data.comDate
            this.treatyPeriodForm.expDate = data.expDate
            this.treatyPeriodDetail = true
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
      }
    },
    doSave() {
      this.$validator.validateAll('treatyPeriodForm').then((result) => {
        if (result) {
          if (this.treatyPeriodForm.treatyPeriodAction === 'new') {
            this.checkTreatyPeriod().then((result) => {
              if (result) {
                this.doCreate()
              }
            })
          } else if (this.treatyPeriodForm.treatyPeriodAction === 'review' || this.treatyPeriodForm.treatyPeriodAction === 'query') {
            this.doUpdate()
          } else {
            this.promptFieldCheck()
          }
        }
      })
    },
    async checkTreatyPeriod() {
      const apiUrl = this.treatyMenu.checkTreatyPeriod
      if (apiUrl) {
        this.submitting = true
        try {
          const expand = {
            ttyNo: this.ttyNoParam,
            ttyYr: this.treatyPeriodForm.ttyYr
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const data = result.data
          // console.log(result)
          // console.log(result.data)
          if (result) {
            // console.log(data)
            if (data !== null && data !== '' && data !== undefined) {
              this.notify(data)
              this.checkTreatyPeriodFound = true
              this.submitting = false
              return false
            } else {
              this.checkTreatyPeriodFound = false
              this.submitting = false
              return true
            }
            // display date in format if query mode
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
        return false
      }
    },
    async doCreate() {
      const apiUrl = this.treatyMenu.createTreatyPeriod
      if (apiUrl) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiUrl, this.treatyPeriodForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiUrl = this.treatyMenu.updateTreatyPeriod
      if (apiUrl) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiUrl, this.treatyPeriodForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.treatyPeriodDetail = false
            this.doInit()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doDeleteTreatyPeriod() {
      const apiUrl = this.treatyMenu.deleteTreatyPeriod
      if (apiUrl) {
        try {
          const expand = this.selectTreatyPeriod
          const result = await this.$http.post(apiUrl, expand)
          const data = result.data
          if (data) {
            this.notify(data)
            this.doInit()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    }
  },
  computed: {
    treatyMenu() {
      return this.$store.state.treatyParam.menu
    },
    ttyNoParam() {
      return this.$route.params.ttyNoParam
    },
    ttyForm() {
      return this.$route.params.ttyForm
    },
    checkComDateValidation() {
      return 'required|comDateValidation:' + this.treatyPeriodForm.ttyYr + ',' + this.treatyPeriodForm.expDate
    },
    checkExpDateValidation() {
      return 'required|expDateValidation:' + this.treatyPeriodForm.ttyYr + ',' + this.treatyPeriodForm.comDate
    }
  },
  created() {
    this.doInit()

    this.$validator.extend('comDateValidation', {
      getMessage(field, args) {
        var ttyYr = args[0]
        var expDate = args[1]
        // var expDateYr = args[2]
        if (ttyYr === expDate) {
          return `Cannot be out of Treaty Year.`
        } else {
          return `Cannot be later than Expiry Date.`
        }
      },
      validate(value, args) {
        if (value) {
          // var ttyYr = args[0]
          var expDate = args[1]
          if (isAfter(removeTime(value), removeTime(expDate))) {
            return false
          } else {
            return true
          }
        }
      }
    })

    this.$validator.extend('expDateValidation', {
      getMessage(field, args) {
        var ttyYr = args[0]
        var comDate = args[1]
        if (ttyYr === comDate) {
          return `Cannot be out of Treaty Year.`
        } else {
          return `Cannot be earlier than Commencement Date.`
        }
      },
      validate(value, args) {
        if (value) {
          // var ttyYr = args[0]
          var comDate = args[1]
          // if (comDate) {
          //   let comDateYr = value.getFullYear()
          //   console.log(comDateYr)
          // }
          // let expDateYr = value.getFullYear()
          // console.log(expDateYr)
          if (isAfter(removeTime(comDate), removeTime(value))) {
            return false
          } else {
            return true
          }
        }
      }
    })
  },
  // props: {
  //   ttyNo: {
  //     type: Object,
  //     default: null
  //   }
  // },
  mixins: [TableConst.default, MessageMixin]
}
</script>
